import styles from '../BundleSummaryCard.module.scss';

import cx from 'classnames';
import React, { RefObject } from 'react';

import { useFeatureFlagsContext } from 'components/FeatureFlags/FeatureFlags';
import { TextV2 } from 'components/TextV2/TextV2';
import type { ICartPricing } from 'hooks/useDCSTypes';

interface IBundleSummaryCardInnerContentProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  pricings?: ICartPricing;
  isExpandUpAnimation?: boolean;
  innerRef?: RefObject<HTMLDivElement>;
  headingRef?: RefObject<HTMLDivElement>;
}

export const BundleSummaryCardInnerContent: React.FC<IBundleSummaryCardInnerContentProps> = ({
  title,
  description,
  isExpandUpAnimation,
  pricings,
  innerRef,
  headingRef,
}) => {
  const { isFlagEnabled } = useFeatureFlagsContext();
  const isDescriptionEnabled = isFlagEnabled('show-product-description-global');

  return (
    <div className={styles.bundleSummaryCardInnerContent} ref={innerRef}>
      <div
        className={cx(styles.bundleSummaryCardHeading, {
          [styles.bundleSummaryCardHeadingExpandUp]: isExpandUpAnimation,
        })}
      >
        <div ref={headingRef}>
          <TextV2 tagName="h2" variant="eyebrow" value={title} className={styles.bundleSummaryCardTitle} />
          {isDescriptionEnabled && (
            <TextV2
              isMarkdown
              value={description}
              tagName="div"
              className={cx(
                styles.bundleSummaryCardDescription,
                { [styles.bundleSummaryCardDescriptionHide]: isExpandUpAnimation },
                { [styles.bundleSummaryCardDescriptionNoPricing]: !pricings },
              )}
              aria-hidden={isExpandUpAnimation}
            />
          )}
        </div>
      </div>
    </div>
  );
};
